import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import App from "./App"
// import Test from "./Test"
import Scan from "./Scan"
import Success from "./Success"
import Franchise from "./Franchise"
import Partner from "./Partner"

export default function BasicExample() {
    // localStorage.setItem("be", "https://atzerogravity.herokuapp.com/")
    localStorage.setItem("be", "https://optimal-brace-370511.el.r.appspot.com/")
    // localStorage.setItem("be", "http://localhost:3002/")
    return (
        <Router>
            <div>
                <Routes>
                    <Route exact path="/" element={<App />} />
                    <Route path="/scan" element={<Scan />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/franchise" element={<Franchise />} />
                    <Route path="/partner" element={<Partner />} />
                </Routes>
            </div>
        </Router>
    );
  }